var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{style:({ 'transform': _vm.rotation }),attrs:{"icon-name":"icon__audio_arrow--40.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }